import { render } from "./theme12.vue?vue&type=template&id=fa077318&scoped=true"
import script from "./theme12.vue?vue&type=script&lang=js"
export * from "./theme12.vue?vue&type=script&lang=js"

import "./theme12.vue?vue&type=style&index=0&id=fa077318&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-fa077318"

export default script